module.exports = __webpack_public_path__ + "img/about us.48d481ff.jpeg";